export const isProbablyValidIBAN = (iban: string): boolean => {
  const firstFourChars = iban.substring(0, 4);
  const firstFourCharsIbanPattern = /^[A-Z]{2}[0-9]{2}$/;

  return firstFourCharsIbanPattern.test(firstFourChars);
};
